module.exports = __webpack_public_path__ + "img/id.3ab72319.png";